import { useCodeListStore } from '@/app/shared/state/CodeListModule';
import { USE_BUSINESS_CENTRAL, useFeatureToggleStore } from '@/stores/feature-toggle-store';
import {computed, defineComponent} from 'vue';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlTestPaymentData',
    props: {},
    setup() {
        const codeListStore = useCodeListStore();
        const featureToggleStore = useFeatureToggleStore();

        const isVisible = computed((): boolean => {
            const environment = codeListStore.applicationInfo?.environment;
            return environment === 'Test' || environment === 'Beta';
        });

        const useBusinessCentral = computed((): boolean => featureToggleStore.getFeatureToggle(USE_BUSINESS_CENTRAL));

        return {
            isVisible,
            useBusinessCentral,
        };
    }
})